module.exports = __webpack_public_path__ + "static/media/ic-onaccount-blue.a6875439.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-onaccount-blue.svg
// module id = 650
// module chunks = 14